import styled from 'styled-components'

export const Wrapper = styled.div`
  position: fixed;
  content: '';
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(26, 25, 25, 0.78);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: auto;
`
